<template>
  <div>
    <!-- TKT-000512: buttons fill the bar and scroll (not overlap) when tight; see the .tax-common-action-bar rule in the style block below. Pick List keeps its own justify-start row. -->
    <div class="d-flex overflow-x-auto tax-common-action-bar">
      <v-btn
        class="input-text-size tax-common-action-btn-email-statement ml-n3"
        id="taxCommonActionBtnEmailStatement"
        v-if="this.togglePrintOrEmail"
        text
        color="blue darken-1"
        @click="handleEmailStatement"
      >
        Email Statement
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-print-statement ml-n3"
        id="taxCommonActionBtnPrintStatement"
        v-if="!this.togglePrintOrEmail"
        text
        color="blue darken-1"
        @click="printStatement"
      >
        Print Statement <br /> AlT + S
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-info-sheet ml-n5"
        id="taxCommonActionBtnInfoSheet"
        text
        color="blue darken-1"
        @click="printInfoSheet"
      >
        Info Sheet <br /> AlT + I
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-pay-now ml-n5"
        :class="{ 'tax-common-pay-now-has-mode': payNowModeLabel }"
        id="taxCommonActionBtnPayNow"
        text
        color="blue darken-1"
        @click="handlePayNow"
      >
        <span class="d-flex flex-column align-center">
          <span>Pay Now <br /> AlT + P</span>
          <!-- The Pay Now settings (Full | Half, Normal | Postmark OK) it will open in -->
          <v-chip
            v-if="payNowModeLabel"
            id="taxCommonPayNowModeChip"
            class="mt-1 px-2"
            color="primary"
            x-small
          >
            {{ payNowModeLabel }}
          </v-chip>
        </span>
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-add-to-list ml-n5"
        id="taxCommonActionBtnAddToList"
        text
        color="blue darken-1"
        @click="addToList"
      >
        Add to List <br /> AlT + A
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-browse-bid ml-n5"
        id="taxCommonActionBtnBrowseBID"
        text
        color="blue darken-1"
        @click="onBrowseBidClick"
      >
        Browse BID <br /> AlT + B
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-browse-paid-by ml-n5"
        id="taxCommonActionBtnBrowsePaidBy"
        text
        color="blue darken-1"
        @click="onBrowsePaidByClick"
      >
        Browse Last Payment
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-create-omit ml-n5"
        id="taxCommonActionBtnCreateOmit"
        text
        color="blue darken-1"
        @click="onCreateOmitClick"
      >
        Create Omit
      </v-btn>

      <v-btn
        class="input-text-size tax-common-action-btn-create-sa ml-n5"
        id="taxCommonActionBtnCreateSA"
        text
        color="blue darken-1"
        @click="onCreateSAClick"
      >
        Create SA
      </v-btn>
  </div>
    <BrowsePaidBy :baseCrudKey="baseCrudKeyForPaidByDialog" />
    <CreateOmitDialog v-if="showIfCreateSA" :baseCrudKey="this.baseCrudKeyForCreateOmit"
    :baseCrudKeyOfMainComponent="this.baseCrudKey"
    :baseCrudKeyForCreateSA="this.baseCrudKeyForCreateSA"
    :baseCrudKeyForCreateNewOmitForm="this.baseCrudKeyForCreateNewOmitForm"
    :selectedRowData="selectedRowData" @callBackForDialogOpen="onCreateOmitCallBack"
    @callBackForNewCreateOmit="onCreateNewOmitRecord" />
    <CreateSAForm v-if="showIfCreateSA" :baseCrudKey="baseCrudKeyForCreateSA"
    @upsertCallBack="upsertRecordsSA" :disableSaveBtn="disableSaveBtn" />
    <CreateOmitForm v-if="showIfCreateSA" :baseCrudKey="baseCrudKeyForCreateOmitForm"
    @upsertCallBack="upsertRecordsForCreateOmit" :disableSaveBtn="disableSaveBtn" />
    <CreateOmitForm v-if="showIfCreateSA" :baseCrudKey="baseCrudKeyForCreateNewOmitForm"
    @upsertCallBack="upsertRecordsForCreateNewOmit" :disableSaveBtn="disableSaveBtn" />
    <CommonPopUp v-model="showOrHidePopUp" :enableFlashTypeMsg="false">
      <template v-slot:customsLabelOrInfo>
        <h4 style="color: #1E88E5;">Wrong Tax Type</h4>
        <p class="mt-3">You must select either a real estate or a special assessment
           record, in order to apply a special assessment to a parcel</p>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openConfirmPopUp()">OK</v-btn>
      </template>
    </CommonPopUp>
    <div>
      <CRUDDialog
        :baseCrudKey='emailStatements'
        :canSave="true"
        :onlyDialogHeaderName="emailStatementHeader"
        dialogDynamicWidth='550'
        canSaveCustomLabel="Send"
        @upsertItem="handleEmailStatements"
      ><template v-slot:[`editedItem`]="{}">
          <EmailStatementDialoge :baseCrudKey="emailStatements" />
        </template>
      </CRUDDialog>
    </div>
    <v-dialog v-model="showMailingDialog" max-width="380" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">Statement Mailing</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          Are you mailing this statement?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmStatementMailed(false)">No</v-btn>
          <v-btn text color="primary" @click="confirmStatementMailed(true)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mapMutations, mapGetters, mapState, mapActions,
} from 'vuex';
import {
  taxFeesUpsertCommon, taxAdjUpsertCommon,
  taxInquryUpsertCommonFromCreateNewOmit,
  taxInquryUpsertCommonForOmitAndSA,
} from './TaxInquiry-Common-logics';
import {
  amountFormat, amountToNumber, pIdFormat, zipDeFormat,
} from '../../../../util/shared/vue-global';
import { clients } from '../../../../util/clients';
import { makeCriteriaStateNullIfEmptyString, taxInquiryCriteriaFilter } from '../../common-utils/CommonTaxFunctionalities';
import { toShortDate } from '../../../../util/shared/tmc-global';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import { entryDateOutsidePostingPeriodMsg, getTaxYearStatus } from '../../common-utils/tax-common.util';
import BrowsePaidBy from './BrowsePaidBy.vue';
import CreateSAForm from './CreateSAForm.vue';
import CreateOmitForm from './CreateOmitForm.vue';
import CreateOmitDialog from './CreateOmitDialog.vue';
import CommonPopUp from '../../common-utils/CommonPopUp.vue';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import EmailStatementDialoge from './EmailStatementDialoge.vue';
import { getRawJwt } from '../../../../util/jwt';
import { generateQueryString } from '../../../common/base/report/report-util';
import '../../../../assets/style.css';
import { printerHandler } from '../../../../util/pdf-to-printer.util';
import { middleSectionParam, middleSectionValue } from '../../../../util/statement-middle-section.util';

const { backendRest } = clients.direct;

export default {
  name: 'CommonActionButtons',
  props: {
    selectedRowData: {
      type: Object,
      default: () => { },
    },
    baseCrudKey: {
      type: String,
      default: 'commonActionButtons',
    },
    fromTaxRollSearch: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BrowsePaidBy,
    CreateSAForm,
    CreateOmitForm,
    CreateOmitDialog,
    CommonPopUp,
    CRUDDialog,
    EmailStatementDialoge,
  },
  data() {
    return {
      baseCrudKeyForBIdDialog: 'browseByBid',
      baseCrudKeyForPaidByDialog: 'browsePaidBy',
      baseCrudKeyForCreateOmit: 'createOmit',
      baseCrudKeyForCreateOmitForm: 'createOmitForm',
      baseCrudKeyForCreateNewOmitForm: 'createNewOmitForm',
      baseCrudKeyForCreateSA: 'createSA',
      isItSaOrOmit: '',
      showMailingDialog: false,
      pendingStatementUrl: null,
      taxIdPolling: null,
      showIfCreateSA: false,
      workstation: getWorkstationNumber(),
      showOrHidePopUp: false,
      messageText: 'false',
      emailStatementHeader: 'Email Send',
      emailStatementCrudKeyPickList: 'emailStatementPickList',
      emailStatements: 'emailStatementsCrudKey',
      disableSaveBtn: false,
    };
  },
  created() {
  },
  computed: {
    ...mapState({
      nextTaxIdForSA: (state) => state.tax.taxInquires.nextTaxIdForSA,
      taxFeeList: (state) => state.base.crud.items.sharedTaxFeeMaster,
      nextTaxIdForOmit: (state) => state.tax.taxInquires.nextTaxIdForOmit,
      isTaxIdClicked: (state) => state.tax.taxInquires.isTaxIdClicked,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData,
      togglePrintOrEmail: (state) => state.tax.taxInquires.togglePrintOrEmail,
      statementSettingItem: (state) => state.SystemConfig.statementSettingItem || {},
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
    }),
    ...mapGetters('base/crud', [
      'isVisible',
      'selectedTab',
      'criteria',
      'item',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    isVisibleProp: {
      get() {
        return this.isVisible(this.baseCrudKey);
      },
      set(value) {
        this.setIsVisible([this.baseCrudKey, value]);
      },
    },
    selectOwnerTab: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'name',
          direction: 'desc',
        },
      ];
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    // The mode Pay Now will open in, when it is not the default (Full, Normal).
    payNowModeLabel() {
      const { half, postmark } = this.halfOrPostmark || {};
      return [half && 'Half', postmark && 'Postmark OK'].filter(Boolean).join(' + ');
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKeyForCreateSA);
      },
      set(value) {
        this.setItem([this.baseCrudKeyForCreateSA, value]);
      },
    },
    editedItemForOmitForm: {
      get() {
        return this.item(this.baseCrudKeyForCreateOmitForm);
      },
      set(value) {
        this.setItem([this.baseCrudKeyForCreateOmitForm, value]);
      },
    },
    editedItemForOmitNewRecord: {
      get() {
        return this.item(this.baseCrudKeyForCreateNewOmitForm);
      },
      set(value) {
        this.setItem([this.baseCrudKeyForCreateNewOmitForm, value]);
      },
    },
    editEmailItemStatements: {
      get() {
        return this.item(this.emailStatements);
      },
      set(value) {
        this.setItem([this.emailStatements, value]);
      },
    },
    getCurrentTaxYear() {
      const getTaxYearStats = getTaxYearStatus();
      return getTaxYearStats.currentTax;
    },
  },
  watch: {
    isTaxIdClicked() {
      this.callToStopTimer();
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setSelectedTab',
      'setCriteria',
      'setItem',
      'setHighlightedId', 'setIndex',
    ]),
    ...mapActions('tax/taxInquiryTabs', [
      'UpsertPickListSingleNMultiplipleHybrid',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxPaymentsWithTaxDetails',
      'upsertTaxInquiryTransaction',
      'callMakeGLobalTaxIdUndefined',
      'generateNextTaxId',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setIsTaxIdClicked',
    ]),
    ...mapActions('tax/taxFee', [
      'upsertTaxFees',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'upsertTaxRollAdjustments',
    ]),
    ...mapActions(['reAuth', 'custumColrFlashMsg', 'flashWarn', 'flashError']),
    ...mapActions('tax/taxInquires', [
      'sendMail',
    ]),
    async addToList() {
      // const multiple = true;
      const pickListProfileName = localStorage.getItem('pick-list-profile-name');
      const itemData = { ...this.selectedRowData };
      const returnVal = this.checkItemIsEmptyOrNor();
      if (returnVal) {
        const item = {
          mutipleIds: [itemData._id],
          // workstation: Number(this.workstation),
          addUnpaids: this.paymentSettingItem.loadUnpaidsAutomatically || false,
        };
        // if profile name is present then use it otherwise use workstation
        if (pickListProfileName) item.profileName = pickListProfileName;
        else item.workstation = Number(this.workstation);
        await this.UpsertPickListSingleNMultiplipleHybrid({ item, baseCrudKey: 'pickListTable' });
        this.$emit('callTheArrowDownShortCut');
      }
    },
    getAuthToken() {
      return getRawJwt();
    },
    checkItemIsEmptyOrNor() {
      const itemData = { ...this.selectedRowData };
      if (Object.keys(itemData).length) return true;
      this.custumColrFlashMsg({ msg: 'Please select a record' });
      return false;
    },
    onCreateOmitCallBack(isItNxtOrPreYear) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const selectedItem = { ...this.selectedRowData };
      const makeTheseFieldsEmpty = ['taxId', 'totalTax', '_id', 'statusCode', 'mtgCode'];
      if (Object.keys(selectedItem).length) {
        makeTheseFieldsEmpty.map((ft) => delete selectedItem[ft]);
        if (isItNxtOrPreYear === 'nxtTaxYear') {
          selectedItem.taxYear += 1;
        } else selectedItem.taxYear = Number(selectedItem.taxYear || null);
        const removedDashesFromPid = (selectedItem.propertyOrParcelId || '').replace(/-/g, '');
        const formattedPid = pIdFormat(removedDashesFromPid, formatPidPositions);
        selectedItem.propertyOrParcelId = formattedPid;
        selectedItem.taxId = null;
        selectedItem.certDateValue = toShortDate();
        selectedItem.penaltyStartDate = toShortDate();
        this.isItSaOrOmit = 'omittedProperties';
        this.showIfCreateSA = false;
        this.startTheCounter(selectedItem, 'o', this.baseCrudKeyForCreateOmitForm);
      }
    },
    // Both of these screens end up creating a tax roll adjustment with no adjustment-date
    // field on the form, so the server stamps adjDate with today and rejects the save if
    // today is outside the open posting period. Stop at the button rather than after the
    // form is filled in.
    //
    // allowBeforePeriod: a today that falls BEFORE the open period is no longer a refusal - the
    // server saves the record under the period's first day and hands back a notice we flash after
    // the save (saveOmitOrSaAdjustmentAndFee). Blocking here would stop the clerk at the button
    // and the omit / SA would never get created at all, which is the case Zach asked us to allow.
    blockIfOutsidePostingPeriod() {
      const msg = entryDateOutsidePostingPeriodMsg(this.taxSettingItem, new Date(), {
        allowBeforePeriod: true,
      });
      if (!msg) return false;
      this.flashWarn(msg);
      return true;
    },
    onCreateSAClick() {
      if (this.blockIfOutsidePostingPeriod()) return;
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const selectedItem = { ...this.selectedRowData };
      const returnVal = this.checkItemIsEmptyOrNor();
      const makeTheseFieldsEmpty = ['taxId', 'schoolDistrict', 'totalTax', '_id'];
      if (returnVal && (selectedItem.taxType === 'R' || selectedItem.taxType === 'S')) {
        // this is for originalTaxDistrict, its only for real-estate(R)
        if (selectedItem.taxType === 'R') selectedItem.originalTaxDistrict = selectedItem.schoolDistrict;
        makeTheseFieldsEmpty.map((ft) => delete selectedItem[ft]);
        const removedDashesFromPid = (selectedItem.propertyOrParcelId || '').replace(/-/g, '');
        const formattedPid = pIdFormat(removedDashesFromPid, formatPidPositions);
        selectedItem.propertyOrParcelId = formattedPid;
        selectedItem.taxType = 'S';
        selectedItem.taxId = null;
        selectedItem.land = 0;
        selectedItem.improvements = 0;
        selectedItem.mobileHome = 0;
        selectedItem.assessorPenalty = 0;
        selectedItem.exemptions = 0;
        selectedItem.certDateValue = toShortDate();
        selectedItem.penaltyStartDate = toShortDate();
        selectedItem.feeAmount = amountFormat(amountToNumber(this.taxSettingItem.saFeeAmount));
        selectedItem.feeNumber = amountToNumber(this.taxSettingItem.saFee);
        // No default adjustment type: 'SA' is not a code any county has in the Shared
        // List (Payne uses SP, Testing SPAS), so it rendered as a bare "SA" with no
        // description and satisfied the dropdown's required rule while the adjustment
        // saved with no type at all. Leave it blank and let that rule force a choice.
        this.isItSaOrOmit = 'specialAssesment';
        this.showIfCreateSA = false;
        this.startTheCounter(selectedItem, 's', this.baseCrudKeyForCreateSA);
      } else this.showOrHidePopUp = true;
    },
    onCreateNewOmitRecord(selectedItem, isItOmitOrSA, crudKey, whichIsIt, isItNewRecord) {
      this.startTheCounter(selectedItem, isItOmitOrSA, crudKey, whichIsIt, isItNewRecord);
    },
    openConfirmPopUp() {
      this.showOrHidePopUp = false;
    },
    startTheCounter(selectedItem, isItOmitOrSA, crudKey, whichIsIt, isItNewRecord) {
      if (this.taxIdPolling) clearInterval(this.taxIdPolling);
      if (!isItNewRecord) this.setItem([crudKey, selectedItem]);
      this.$nextTick(() => {
        this.showIfCreateSA = true;
      });
      this.setIsVisible([crudKey, true]);
      if (this.taxSettingItem[whichIsIt || this.isItSaOrOmit]) {
        this.taxIdPolling = setInterval(() => {
          this.determineNextTaxId(selectedItem, isItOmitOrSA, crudKey, isItNewRecord);
        }, 1200);
      }
    },
    determineNextTaxId(selectedItem, isItOmitOrSA, crudKey, isItNewRecord) {
      const selectItem = { ...selectedItem };
      const dialogIsOpenOrNot = this.isVisible(crudKey);
      if (dialogIsOpenOrNot) {
        const loadTaxPromise = this.generateNextTaxId(
          {
            taxYear: selectItem.taxYear,
            type: isItOmitOrSA,
          },
        );
        loadTaxPromise.then(() => {
          if (isItOmitOrSA === 's') this.editedItem.taxId = this.nextTaxIdForSA; // for SA
          else if (!isItNewRecord && isItOmitOrSA === 'o') { // for Omit
            this.editedItemForOmitForm.taxId = this.nextTaxIdForOmit;
          } else { // for create-new-omit
            this.editedItemForOmitNewRecord.taxYear = selectItem.taxYear;
            this.editedItemForOmitNewRecord.taxId = this.nextTaxIdForOmit;
            this.editedItemForOmitNewRecord.baseId = this.nextTaxIdForOmit;
          }
        });
      } else clearInterval(this.taxIdPolling);
    },
    getCriteriaForTaxRollScreen(criteria) {
      const selectedCriteria = {
        taxYear: criteria.taxYear,
        baseId: criteria.baseId,
        skip: 0,
        sortBy: criteria.sortBy,
        limit: criteria.limit,
        penaltyDateValue: criteria.penaltyDateValue,
      };
      return selectedCriteria;
    },
    async onBrowseBidClick() {
      if (!this.fromTaxRollSearch) {
        const taxRollBaseCrudKey = 'TaxrollTransactionList';
        const getCriteria = this.criteria(taxRollBaseCrudKey);
        const selectedItem = { ...this.selectedRowData };
        getCriteria.taxYear = 0;
        getCriteria.baseId = selectedItem.baseId;
        const returnCriteria = taxInquiryCriteriaFilter(getCriteria);
        const returnVal = this.checkItemIsEmptyOrNor();
        if (returnVal) {
          // resetting the criteria for tax roll screen
          const criteria = this.getCriteriaForTaxRollScreen(returnCriteria);
          criteria.fromOwnerSearch = true;
          this.setCriteria([taxRollBaseCrudKey, criteria]);
          this.$router.push({ path: '/tax/taxinquiry/taxrollsearch' }).catch((error) => {
            console.info(error);
          });
        }
      } else {
        const getCriteria = this.criteria(this.baseCrudKey);
        const selectedItem = { ...this.selectedRowData };
        getCriteria.taxYear = 0;
        getCriteria.baseId = selectedItem.baseId;
        const returnCriteria = taxInquiryCriteriaFilter(getCriteria);
        const returnVal = this.checkItemIsEmptyOrNor();
        if (returnVal) {
          // resetting the criteria for tax roll screen
          const criteria = this.getCriteriaForTaxRollScreen(returnCriteria);
          this.setCriteria([this.baseCrudKey, criteria]);
          this.$emit('onBrowseBidClicked', criteria, 'fromBrowseBidClick');
        }
      }
    },
    async onBrowsePaidByClick() {
      const selectedItem = { ...this.selectedRowData };
      const returnVal = this.checkItemIsEmptyOrNor();
      if (returnVal) {
        this.setIsVisible([this.baseCrudKeyForPaidByDialog, true]);
        const criteria = { baseId: selectedItem.baseId };
        const fields = {
          _id: '',
          taxYear: '',
          name1: '',
          taxId: '',
          baseId: '',
          situsAddress: '',
          paidBy: '',
          payDate: '',
        };
        await this.loadTaxPaymentsWithTaxDetails({
          criteria, baseCrudKey: this.baseCrudKeyForPaidByDialog, fields,
        });
      }
      this.$emit('setDefaultSelectedItems');
    },
    // Create Omit and Create SA write three records: the adjustment, the fee and the tax
    // record. The adjustment now goes FIRST and the save stops dead if it fails, because the
    // half-record this used to leave behind cannot be seen from any screen - a tax record
    // carrying tax with no adjustment behind it never reaches the Adjustment Report, the Tax
    // Roll Adjustment screen or the tax roll summary's plusAdj/adjTax/uncollected, and Tax
    // Inquiry shows nothing missing. It took the county to notice (Tulsa, 2025 mobile home
    // omits 8001562 and 8001563, created 2026-09-25 by a TaxUser with no adjustment role once
    // the server started refusing new adjustments; both repaired by hand).
    //
    // fromCreateOmitOrSA tells the resolver this adjustment belongs to an omit/SA rather than
    // to manual entry on the Adjustment tab, so the Adjustment-program-access gate on new
    // adjustments does not apply - anyone who can create an omit or an SA must get its
    // adjustment saved.
    async saveOmitOrSaAdjustmentAndFee(itemList) {
      const { baseCrudKey } = this;
      const feeItem = taxFeesUpsertCommon(itemList, this.taxFeeMasterData);
      let savedAdj;
      try {
        savedAdj = await this.upsertTaxRollAdjustments({
          item: taxAdjUpsertCommon(itemList),
          baseCrudKey,
          fromCreateOmitOrSA: true,
          throwOnError: true,
        });
      } catch (e) {
        this.disableSaveBtn = false;
        const gqlMsg = ((e || {}).graphQLErrors || [])
          .map((err) => err.message).filter(Boolean).join('; ');
        const reason = (gqlMsg || (e || {}).message || 'unknown error')
          .replace('403 Forbidden', 'you do not have access to save it');
        this.flashError(`Nothing was saved. The adjustment could not be saved: ${reason}`);
        return { ok: false };
      }
      if (feeItem && Object.keys(feeItem).length) await this.upsertTaxFees({ item: feeItem });
      // Handed back rather than flashed here: the snackbar holds ONE message (store/index.js
      // setMessage replaces it), and the tax record save that follows raises its own. Each caller
      // flashes this last, once everything has landed.
      return { ok: true, feeItem, postingPeriodNotice: (savedAdj || {}).postingPeriodNotice };
    },
    async upsertRecordsSA(val) {
      this.disableSaveBtn = true;
      const itemList = { ...val };
      delete itemList._id;
      const { baseCrudKey } = this;
      const { ok, feeItem, postingPeriodNotice } = await this.saveOmitOrSaAdjustmentAndFee(itemList);
      if (!ok) return;
      const taxInquiryUpsert = taxInquryUpsertCommonForOmitAndSA(itemList);
      const returnRes = makeCriteriaStateNullIfEmptyString(taxInquiryUpsert);
      returnRes.zip = zipDeFormat(returnRes.zip);
      returnRes.adjustments = returnRes.totalTax;
      // when fees gets updated in the upsertTaxFees only totalFees(for taxInquiry collection)
      // is updated, so we need to update feesAndPen
      returnRes.feesAndPen = (returnRes.totalTax || 0) + (feeItem.feeAmount || 0);
      delete returnRes.commentForTaxInfoChanges;
      delete returnRes.commentOnlyForOwner;
      delete returnRes.beforeChange;
      delete returnRes.afterChange;
      delete returnRes.beforeChangeForTax;
      delete returnRes.afterChangeForTax;
      delete returnRes.commentCreatedDate;
      delete returnRes.totalDueIsNegative;
      await this.upsertTaxInquiryTransaction({
        item: returnRes, baseCrudKey, isItOmitOrSa: true,
      }).then(() => {
        this.disableSaveBtn = false;
        this.$emit('onBrowseBidClicked');
        this.setItem([this.baseCrudKeyForCreateSA, {}]);
        this.setItem([this.baseCrudKeyForCreateOmitForm, {}]);
        this.setIsVisible([this.baseCrudKeyForCreateOmit, false]);
        this.setIsVisible([this.baseCrudKeyForCreateSA, false]);
      });
      await this.callMakeGLobalTaxIdUndefined({ type: this.isItSaOrOmit });
      // Last, so the tax record save's own message does not replace it: the record was filed
      // under the first day of the open posting period rather than today.
      if (postingPeriodNotice) this.flashWarn(postingPeriodNotice);
    },
    async upsertRecordsForCreateOmit(val) {
      this.disableSaveBtn = true;
      const itemList = { ...val };
      delete itemList._id;
      const { baseCrudKey } = this;
      const { ok, feeItem, postingPeriodNotice } = await this.saveOmitOrSaAdjustmentAndFee(itemList);
      if (!ok) return;
      const taxInquiryUpsert = taxInquryUpsertCommonForOmitAndSA(itemList);
      const returnRes = makeCriteriaStateNullIfEmptyString(taxInquiryUpsert);
      if (!!itemList.certificateNumber && returnRes.taxType === 'M') {
        returnRes.certNumber = amountToNumber(itemList.certificateNumber);
      }
      returnRes.zip = zipDeFormat(returnRes.zip);
      returnRes.adjustments = returnRes.totalTax;
      // when fees gets updated in the upsertTaxFees only totalFees(for taxInquiry collection)
      // is updated, so we need to update feesAndPen
      returnRes.feesAndPen = (returnRes.totalTax || 0) + (feeItem.feeAmount || 0);
      delete returnRes.commentForTaxInfoChanges;
      delete returnRes.commentOnlyForOwner;
      delete returnRes.beforeChange;
      delete returnRes.afterChange;
      delete returnRes.beforeChangeForTax;
      delete returnRes.afterChangeForTax;
      delete returnRes.commentCreatedDate;
      delete returnRes.totalDueIsNegative;
      await this.upsertTaxInquiryTransaction({
        item: returnRes, baseCrudKey, isItOmitOrSa: true,
      }).then(() => {
        this.disableSaveBtn = false;
        this.$emit('onBrowseBidClicked');
        this.setItem([this.baseCrudKeyForCreateSA, {}]);
        this.setItem([this.baseCrudKeyForCreateNewOmitForm, {}]);
        this.setIsVisible([this.baseCrudKeyForCreateOmit, false]);
        this.setIsVisible([this.baseCrudKeyForCreateOmitForm, false]);
      });
      await this.callMakeGLobalTaxIdUndefined({ type: this.isItSaOrOmit });
      // Last, so the tax record save's own message does not replace it: the record was filed
      // under the first day of the open posting period rather than today.
      if (postingPeriodNotice) this.flashWarn(postingPeriodNotice);
    },
    async upsertRecordsForCreateNewOmit(val) {
      this.disableSaveBtn = true;
      const itemList = { ...val };
      delete itemList._id;
      const { baseCrudKey } = this;
      const { ok, feeItem, postingPeriodNotice } = await this.saveOmitOrSaAdjustmentAndFee(itemList);
      if (!ok) return;
      const taxInquiryUpsert = taxInquryUpsertCommonFromCreateNewOmit(itemList);
      const returnRes = makeCriteriaStateNullIfEmptyString(taxInquiryUpsert);
      if (!!itemList.certificateNumber && returnRes.taxType === 'M') {
        returnRes.certNumber = amountToNumber(itemList.certificateNumber);
      }
      returnRes.zip = zipDeFormat(returnRes.zip);
      returnRes.adjustments = returnRes.totalTax;
      // when fees gets updated in the upsertTaxFees only totalFees(for taxInquiry collection)
      // is updated, so we need to update feesAndPen
      returnRes.feesAndPen = (returnRes.totalTax || 0) + (feeItem.feeAmount || 0);
      delete returnRes.commentForTaxInfoChanges;
      delete returnRes.commentOnlyForOwner;
      delete returnRes.beforeChange;
      delete returnRes.afterChange;
      delete returnRes.beforeChangeForTax;
      delete returnRes.afterChangeForTax;
      delete returnRes.commentCreatedDate;
      delete returnRes.totalDueIsNegative;
      await this.upsertTaxInquiryTransaction({
        item: returnRes, baseCrudKey, isItOmitOrSa: true,
      }).then(() => {
        this.disableSaveBtn = false;
        this.$emit('onBrowseBidClicked');
        this.setItem([this.baseCrudKeyForCreateSA, {}]);
        this.setItem([this.baseCrudKeyForCreateNewOmitForm, {}]);
        this.setIsVisible([this.baseCrudKeyForCreateOmit, false]);
        this.setIsVisible([this.baseCrudKeyForCreateNewOmitForm, false]);
      });
      await this.callMakeGLobalTaxIdUndefined({ type: this.isItSaOrOmit });
      // Last, so the tax record save's own message does not replace it: the record was filed
      // under the first day of the open posting period rather than today.
      if (postingPeriodNotice) this.flashWarn(postingPeriodNotice);
    },
    onCreateOmitClick() {
      // const selectedItem = { ...this.selectedRowData };
      if (this.blockIfOutsidePostingPeriod()) return;
      const returnVal = this.checkItemIsEmptyOrNor();
      // if (returnVal && selectedItem.taxType !== 'S') {
      //   this.showIfCreateSA = true;
      //   this.setIsVisible([this.baseCrudKeyForCreateOmit, true]);
      // }
      if (returnVal) {
        this.showIfCreateSA = true;
        this.setIsVisible([this.baseCrudKeyForCreateOmit, true]);
      }
    },
    async handlePayNow() {
      this.setDefaultSelectedItems();
      const returnVal = this.checkItemIsEmptyOrNor();
      // this.setIndex(['paymentTransactionList', -1]);
      if (returnVal) this.$emit('emitPaymentDialog');
    },
    async printStatement() {
      if (!this.togglePrintOrEmail) {
        const item = { ...this.selectedRowData };
        if (!item._id) {
          alert('Please select at least one record');
          return;
        }

        const { jwt } = await this.reAuth();
        const params = [
          `token=${jwt}`,
          `wkst=${Number(this.workstation)}`,
          `penaltyDate=${this.criteriaState.penaltyDateValue}`,
          `ids=${item._id}`,
          // TKT-000862: this workstation's Middle Section choice. Empty on County Setting,
          // and generateQueryString drops empty params, so nothing is sent and the backend
          // prints from Settings > Statements exactly as it does today.
          middleSectionParam(),
        ];
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/taxInquiry/pick-list/printStatement${queryString}`;
        if (this.taxSettingItem.addCommentOnStatementMailed) {
          this.pendingStatementUrl = url;
          this.showMailingDialog = true;
        } else {
          printerHandler(this, { url, reportName: 'taxStatements', deafultPrinterMode: true });
        }
      } else {
        console.info('object');
      }
    },
    confirmStatementMailed(isMailed) {
      this.showMailingDialog = false;
      if (!this.pendingStatementUrl) return;
      const url = isMailed
        ? `${this.pendingStatementUrl}&mailedStatement=1`
        : this.pendingStatementUrl;
      printerHandler(this, { url, reportName: 'taxStatements', deafultPrinterMode: true });
      this.pendingStatementUrl = null;
    },
    handleEmailStatement() {
      const itemData = this.item(this.baseCrudKey);
      if (!itemData._id) {
        alert('Please select at least one record');
        return;
      }
      const penDate = this.editedItem.curPenaltyDate
        ? toShortDate(this.editedItem.curPenaltyDate) : toShortDate();
      this.editEmailItemStatements.wkstID = Number(this.workstation);
      this.editEmailItemStatements.penaltyDate = penDate;
      this.editEmailItemStatements.emailAdd = itemData.emailAddess;
      // Default ON when the record has no address on file yet, OFF when the field is
      // pre-filled with what's already stored - the user can always override before sending.
      this.editEmailItemStatements.saveEmailToRecord = !itemData.emailAddess;
      this.editEmailItemStatements.bccEmailAddress = this.statementSettingItem.bccEmailAddress;
      this.editEmailItemStatements.subjectLine = this.statementSettingItem.subjectLine;
      this.editEmailItemStatements.subjectBody = this.statementSettingItem.subjectBody;
      this.setIsVisible([this.emailStatements, true]);
    },
    async handleEmailStatements() {
      const {
        bccEmailAddress, emailAdd, subjectBody, subjectLine, wkstID, penaltyDate, saveEmailToRecord,
      } = this.editEmailItemStatements;
      const itemData = this.item(this.baseCrudKey);
      const item = {
        email: emailAdd,
        bccEmailAddress,
        subject: subjectLine,
        subjectBody,
        saveEmailToRecord: !!saveEmailToRecord,
        token: this.getAuthToken(),
        wkstID,
        wkst: Number(this.workstation),
        ids: itemData._id,
        penaltyDate,
      };
      // TKT-000862: same Middle Section choice as Print Statement. Set only when this
      // workstation is overriding - the item is url-encoded whole, and an always-present key
      // would send middleSection= (or 'undefined') on every county-setting email.
      const middleSection = middleSectionValue();
      if (middleSection) item.middleSection = middleSection;
      this.sendMail({ item });
      // alert('handle email', item);
    },
    async printInfoSheet() {
      if (!this.togglePrintOrEmail) {
        const item = { ...this.selectedRowData };
        if (!item._id) {
          alert('Please select at least one record');
          return;
        }
        const { jwt } = await this.reAuth();
        const to = `taxInquiry/pick-list/printInfoSheet?ids=${item._id}&token=${jwt}&wkst=${Number(this.workstation)}`;
        const toUrl = `${backendRest.defaults.baseURL}/${to}`;
        // window.open(toUrl);
        printerHandler(this, { url: toUrl, reportName: 'infoSheets', deafultPrinterMode: true });
      } else {
        console.info('object');
      }
    },
    callToStopTimer() {
      clearInterval(this.taxIdPolling);
      this.setIsTaxIdClicked(false);
    },
    setDefaultSelectedItems() {
      this.setHighlightedId([this.baseCrudKey, '']);
    },
  },
};
</script>

<style scoped>
/* TKT-000512: spread the action buttons across the full available width and let
   them resize as the window grows/shrinks (fill), rather than clustering to the
   left or grouping in the center. The Pick List keeps its own justify-start row. */
.tax-common-action-bar {
  gap: 4px;
}
.tax-common-action-bar > .v-btn {
  flex: 1 0 auto;
  margin-left: 0 !important;
}
/* Room for the mode chip under the two-line label; the button is 36px otherwise. */
.tax-common-action-bar > .v-btn.tax-common-pay-now-has-mode {
  height: auto;
  min-height: 36px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.tax-common-action-bar .v-chip {
  text-transform: none;
}
</style>
